import { render, staticRenderFns } from "./SafetyPlanDetailDialog.vue?vue&type=template&id=3033661b"
import script from "./SafetyPlanDetailDialog.vue?vue&type=script&lang=js"
export * from "./SafetyPlanDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports